import { render, staticRenderFns } from "./StatusStep.vue?vue&type=template&id=6829fcc6&scoped=true"
import script from "./StatusStep.vue?vue&type=script&lang=js"
export * from "./StatusStep.vue?vue&type=script&lang=js"
import style0 from "./StatusStep.vue?vue&type=style&index=0&id=6829fcc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829fcc6",
  null
  
)

export default component.exports